const NESTED_INTERACTION_SELECTORS = [
    '.w5-cell-favorite',
    '.w5-cell-checkbox',
    '.w5-group-chevron',
    '.w5-toggle-cell',
    '.w5-icon-cell-pointer',
    '.w5-cell__custom-dragger',
    '[class*="actionsContainer"]',
];

/**
 * Returns true when the click target is inside a nested interactive control within a
 * DataGrid cell (favorite, checkbox, expand chevron, toggle, icon action, row actions).
 *
 * @param {EventTarget | null | undefined} target
 * @returns {boolean}
 */
export function isDataGridCellNestedInteraction(target) {
    if (!target || typeof target.closest !== 'function') return false;

    return NESTED_INTERACTION_SELECTORS.some((selector) => target.closest(selector));
}
